import { render } from "./Datatable.vue?vue&type=template&id=074bd86b&ts=true"
import script from "./Datatable.vue?vue&type=script&lang=ts"
export * from "./Datatable.vue?vue&type=script&lang=ts"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_adm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__